(() => {
  // app/scripts/popup-component.js
  customElements.define("popup-assessment-component", class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      let closeElm = this.querySelectorAll(".jsClose");
      closeElm?.forEach((elm) => {
        elm.addEventListener("click", this.close.bind(this));
      });
    }
    close() {
      this.style.display = "none";
    }
  });
})();
